<div class="tab-content"
     [ngClass]="(isMobile$ | async) && showDocsFilters ? 'gap-200' : 'gap-100'">
  @if (!!documents && !!documents.length) {
    <!-- Actions cards -->
    <div hidden *ngIf="!(isMobile$ | async)" class="flex gap-100">
      @for (doc of ['MBL', 'HBL']; track doc) {
        <nz-card *ngIf="!!authService.loggedUser$.value?.uploadDocumentsUnlimited || !!authService.loggedUser$.value?.uploadDocumentsLimited"
                 nzHoverable (click)="openUploadDocsModal(entityId, entityType)" style="width: 100%; max-width: 330px">
          <div class="flex-center-between">
            <div class="flex-center gap-100">
              <app-st-icon [avatar]="true" [name]="'file_copy_off'"></app-st-icon>
              <span class="text-label-14 text-dark text-semibold">{{ doc }}</span>
            </div>

            <button class="flex-center gap-075" nzShape="round" nzSize="small" nz-button
                    nzType="default">
              <app-st-icon class="text-btn-16 prefix" [bold]="true" name="upload"></app-st-icon>
              <span class="text-btn-14">Subir</span>
            </button>
          </div>
        </nz-card>
      }
    </div>

    <!-- Filtros generales y btns de acciones -->
    <div class="flex-center-between gap-150 no-scroll-bar" style="padding-left: 17px;">
      <div class="flex-center gap-150" style="min-width: fit-content">
        <label nz-checkbox [nzIndeterminate]="isIndeterminate" [nzChecked]="isAllSelected"
               (nzCheckedChange)="toggleSelectAllDocs()"></label>

        <!-- Filtros (Desktop) -->
        <ng-container *ngIf="!(isMobile$ | async)" [ngTemplateOutlet]="filtersTmpl"></ng-container>

      </div>

      <div class="btns-wrapper flex-center gap-150">

        @if (docCardsActivate.length > 0) {
          <button *ngIf="!!authService.loggedUser$.value?.uploadDocumentsUnlimited || !!authService.loggedUser$.value?.uploadDocumentsLimited"
                  class="flex-center" [nzShape]="'circle'"
                  (click)="openDeleteModal()" nzSize="default" nz-button [nzType]="'primary'" nzDanger>
            <app-st-icon class="text-btn-16" [bold]="true" name="delete"></app-st-icon>
          </button>

          <!--          <button class="flex-center gap-075" [nzShape]="(isMobile$ | async) ? 'circle' : 'round'"-->
            <!--                  nzSize="default" nz-button [nzType]="(isMobile$ | async) ? 'text' : 'default'">-->
            <!--            <app-st-icon [class.prefix]="!(isMobile$ | async)" class="text-btn-16" [bold]="true" name="download"></app-st-icon>-->
            <!--            <span *ngIf="!(isMobile$ | async)" class="text-btn-14">Descargar</span>-->
            <!--          </button>-->
        }

        <button *ngIf="isMobile$ | async" (click)="toggleShowDocsFilters()" class="text-btn-14" nz-button
                style="margin-right: auto"
                [nzType]="showDocsFilters ? 'primary' : 'default'" nzShape="round" nzSize="default">
          <app-st-icon class="prefix" [name]="'filter_alt'" [bold]="true"></app-st-icon>
          <span>Filtros</span>
        </button>

        <button *ngIf="!!authService.loggedUser$.value?.uploadDocumentsUnlimited || !!authService.loggedUser$.value?.uploadDocumentsLimited"
                (click)="openUploadDocsModal(entityId, entityType)" class="flex-center gap-075" nzSize="default"
                nz-button
                [nzShape]="(isMobile$ | async) ? 'circle' : 'round'"
                [nzType]="(isMobile$ | async) ? 'default' : 'primary'">
          <app-st-icon [class.prefix]="!(isMobile$ | async)" class="text-btn-16 flex-center"
                       [bold]="true" name="upload"></app-st-icon>
          <span *ngIf="!(isMobile$ | async)" class="text-btn-14">Subir documentos</span>
        </button>
      </div>
    </div>

    <!-- Filtros (Mobile) -->
    <ng-container *ngIf="(isMobile$ | async)" [ngTemplateOutlet]="filtersTmpl"></ng-container>

    <div class="flex flex-column gap-100">
      @for (doc of filteredDocuments; track doc.id) {
        <app-doc-info-card
          (click)="onDocCardClick(doc)"
          (onActionBtnEvent)="onActionBtn($event, doc)"
          [isActive]="this.docCardsActivate.includes(doc.id)"
          [document]="doc"
          [entityId]="entityId"
          [entityType]="entityType"
        ></app-doc-info-card>
      }
    </div>
  } @else {
    <app-empty-state [icon]="'upload_file'"
                     (btnPressEvent)="openUploadDocsModal(entityId, entityType)"
                     [hideBtn]="(!authService.loggedUser$.value?.uploadDocumentsUnlimited && !authService.loggedUser$.value?.uploadDocumentsLimited)"
                     [object]="'documentos'" [btnIcon]="'upload'" [btnText]="'Subir documentos'"></app-empty-state>
  }
</div>


<ng-template #filtersTmpl>
  <div class="doc-filter-cont flex-center gap-150">
    @for (filter of documentsFilters; track filter) {
      <div [class.hidden]="filter.hidden || (isMobile$ | async) && !showDocsFilters"
           (click)="filter.name !== 'Tipo de documento' ? onFilterSelect(filter.name) : null"
           [nzDropdownMenu]="filter.name === 'Tipo de documento' ? documentTypeMenu : null"
           nz-dropdown [nzTrigger]="'click'"
           class="st-badget" [ngClass]="filter.active ? 'black' : 'subtle-grey'">
        <app-st-icon *ngIf="filter.icon !== ''" [name]="filter.icon"></app-st-icon>
        <label>{{ filter.name }}</label>
      </div>
    }
  </div>
  <!-- Menú desplegable para DocumentTypes -->
  <nz-dropdown-menu #documentTypeMenu="nzDropdownMenu">
    <ul nz-menu>
      @if(documentTypesAvailable.length>0){
        @for (type of documentTypesAvailable; track type) {
          <li nz-menu-item [class.bg-grey-1]="type.name === documentTypeFiltervalue"
              (click)="onFilterSelect('Tipo de documento', type.name)">
            {{ type.name }}
          </li>
        }
      } @else {
        <li nz-menu-item disabled>
          Sin tipo
        </li>
      }
    </ul>
  </nz-dropdown-menu>
</ng-template>

<!--<app-confirmation-modal #confirmationModal (confirmed)="onDeleteConfirmed()"></app-confirmation-modal>-->
